import { formReveal } from '../utilities/_helpers.js';

document.addEventListener('DOMContentLoaded', () => {
  formReveal([{ block: '.image-mixed-content', contentSelector: '.content-holder' }]);
});
